import type { FaireProductEntity } from "../../entity_types/product";

export const p_r46n4hck59: FaireProductEntity = {
  token: "p_r46n4hck59",
  type: "product",
  name: "Wild Herb Tonic - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7f2c4a04d6464cd0d0d1221098e0b920431d316bc4b965485a4e748ff1c505b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c74a9b8b4b55f37d02e379cfbff61c2db206d1fdd36e8902621ecce3651a0e8.jpeg",
    "https://cdn.faire.com/fastly/db46bd2655eb458d1bae25bb1c4e86420aa26652038a69724f6f8e28e99d4bb9.jpeg",
    "https://cdn.faire.com/fastly/991cc771a620cb74098a25def67cc8cef09f963d6580b32fce5bf1c1547fbe10.jpeg",
    "https://cdn.faire.com/fastly/91c0f84eac41fd0ea6f233c05ae7bfe2c6d9787569d4d4ced5f3d713276df01a.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "Barefoot walks through wild herb gardens, cool mountain stream baths, crisp morning air. Lemon balm, thyme, orange, fir.\n\nOur best-selling 7.2 oz Standard Size. This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:45.073Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
